import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ListenableEvent } from "../utils";
export class AppSettings {
    /** Settings for the snapping. Used from tools with snapping support. */
    get snapping() {
        return (this.mSnapping);
    }
    constructor() {
        this.eventSnappingChanged = new ListenableEvent(this);
        this.mSnapping = {
            gridEnabled: true,
            gridDynamic: true,
            gridSize: new Vector3(0.1, 0.1, 0.1),
            boundingBoxEnabled: true
        };
    }
    /** Set new snapping settings. Undefined settings will not be changed. */
    setSnapping(pSettings) {
        Object.assign(this.mSnapping, pSettings);
        this.eventSnappingChanged.trigger();
    }
}
